import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

import { CcServiceDemoCardHeader } from "@/components/services/shared/CcServiceDemoCardHeader";

type CcSeoWorkflowCardProps = {
  id: string;
  title: string;
  description: string;
  badge?: string;
  icon?: LucideIcon;
  children?: ReactNode;
};

export function CcSeoWorkflowCard({
  id,
  title,
  description,
  badge,
  icon,
  children,
}: CcSeoWorkflowCardProps) {
  const titleId = `cc-seo-workflow-${id}-title`;

  return (
    <article
      id={`cc-seo-workflow-${id}`}
      className="cc-seo-workflow-card cc-service-demo-card"
      aria-labelledby={titleId}
    >
      <CcServiceDemoCardHeader
        title={title}
        titleId={titleId}
        description={description}
        badge={badge}
        icon={icon}
      />
      <div className="cc-seo-workflow-card__body">
        <div className="cc-seo-workflow-card__visual">{children}</div>
      </div>
    </article>
  );
}
